import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "linking-input" }
const _hoisted_2 = { class: "linking-input__title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "linking-input__sub-title sub-title" }
const _hoisted_5 = { class: "sub-title__prefix" }
const _hoisted_6 = { class: "sub-title__suffix" }
const _hoisted_7 = { class: "linking-input__linking-container" }
const _hoisted_8 = {
  key: 0,
  class: "linking-input__order-save-mode order-save-mode"
}
const _hoisted_9 = { class: "order-save-mode__option" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = {
  key: 0,
  class: "order-save-mode__option"
}
const _hoisted_12 = ["checked"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "linking-input__button-container" }

import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { RegisterSettingStore } from '../../RegisterSettingStore';
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';
import InputExcelForm from '../inputExcelForm/InputExcelForm.vue';
import InputOrderExcelForm from '../inputExcelForm/InputOrderExcelForm.vue';
import { AlterableHeaderInfo } from '../../interfaces/LinkingInput';
import { OrderExcelInfoSaveMode } from '../../interfaces/LinkingInput';
import { RegisterOrderExcelInfos } from '@/coreDomainsModule/entities/InputOrderExcelInfo';
import { UNSELECTED_HEADER_VALUE } from '@/registerInputModule/constants';

export default /*@__PURE__*/_defineComponent({
  __name: 'LinkingInput',
  props: {
    store: {}
  },
  emits: ["on-click-next", "on-click-back"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const { state } = storeToRefs(props.store);
const selectedFieldId = ref<string>('');

const emits = __emit;

const imagesRequire = require.context('@/assets/img', false, /^\.\/register-input-step-flow-2.*\.png$/);
const localedRegisterInputStepFlowImage = ref(imagesRequire('./register-input-step-flow-2.png'));

watch(
  () => i18n.locale,
  (newVal) => {
    localedRegisterInputStepFlowImage.value =
      newVal === 'en' ? imagesRequire('./register-input-step-flow-2__en.png') : imagesRequire('./register-input-step-flow-2.png');
  },
  {
    immediate: true,
  }
);

/**
 * 選択されたフィールドを更新する
 * @param header - フィールド
 * @param updateValue - 更新する値
 */
const updateSelectedField = (header: AlterableHeaderInfo, updateValue: string) => {
  // 選択された値を更新
  state.value.linkingInput.alternateHeaderInfos = state.value.linkingInput.alternateHeaderInfos.map((linkedHeader) => {
    if (linkedHeader.header === header.header) {
      // 選択された値が「未選択」の場合は空文字列にする
      return {
        ...linkedHeader,
        value: updateValue !== UNSELECTED_HEADER_VALUE ? updateValue : '',
      };
    }
    return linkedHeader;
  });
};

/**
 * 戻るボタン
 */
const onClickBackButton = () => {
  emits('on-click-back');
};

/**
 * 次へボタン
 */
const onClickNextButton = () => {
  emits('on-click-next');
};

const selectedFieldSuggestions = computed(() => {
  return state.value.uploadInput.headerCandidates.map((candidate) => candidate.value);
});

const savedOrderExcelInfos = computed(() => {
  return state.value.homeInput.inputExcelInfo?.Order ?? [];
});

/**
 * setter
 * @param updateValue - 更新する値
 */
const updateInlineHeaderName = (updateValue: string) => {
  state.value.linkingInput.inlinedYearMonthInfo.headerName = updateValue;
};

/**
 * setter
 * @param updateValue - 更新する値
 */
const updateInHeaderStartColumnNumber = (updateValue: string) => {
  state.value.linkingInput.inHeaderYearMonthInfo.startColumnNumber = {
    ...state.value.linkingInput.inHeaderYearMonthInfo.startColumnNumber,
    raw: updateValue,
  };
};

/**
 * setter
 * @param updateValue - 更新する値
 */
const updateInHeaderEndColumnNumber = (updateValue: string) => {
  state.value.linkingInput.inHeaderYearMonthInfo.endColumnNumber = {
    ...state.value.linkingInput.inHeaderYearMonthInfo.endColumnNumber,
    raw: updateValue,
  };
};

/**
 * setter
 * @param updateValue - 更新する値
 */
const updateInHeaderStart = (updateValue: string) => {
  state.value.linkingInput.inHeaderYearMonthInfo.start = {
    ...state.value.linkingInput.inHeaderYearMonthInfo.start,
    raw: updateValue,
  };
};

/**
 * setter
 * @param updateValue - 更新する値
 */
const updateInHeaderEnd = (updateValue: string) => {
  state.value.linkingInput.inHeaderYearMonthInfo.end = {
    ...state.value.linkingInput.inHeaderYearMonthInfo.end,
    raw: updateValue,
  };
};

/**
 * 発注読み込み設定を更新する
 * @param orderExcelInfos - 発注読み込み設定一覧
 */
const updateOrderExcelInfos = (orderExcelInfos: RegisterOrderExcelInfos) => {
  state.value.linkingInput.orderExcelInfos = orderExcelInfos;
};

/**
 * 発注読み込み設定の保存方法を更新する
 * @param saveMode - 保存方法
 */
const updateOrderExcelInfoSaveMode = (saveMode: OrderExcelInfoSaveMode) => {
  state.value.linkingInput.orderExcelInfoSaveMode = saveMode;

  if (saveMode === 'replace' && !state.value.linkingInput.orderExcelInfoReplaceTargetId) {
    state.value.linkingInput.orderExcelInfoReplaceTargetId = savedOrderExcelInfos.value[0]?.id ?? '';
  }
};

/**
 * 置き換える発注読み込み設定IDを更新する
 * @param event - 変更イベント
 */
const updateOrderExcelInfoReplaceTargetId = (event: Event) => {
  state.value.linkingInput.orderExcelInfoReplaceTargetId = (event.target as HTMLSelectElement).value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('取引紐付け：タイトル')), 1),
    _createElementVNode("img", {
      src: localedRegisterInputStepFlowImage.value,
      class: "linking-input__progress"
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('取引紐付け：本文')), 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('取引紐付け：注釈')), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_unref(state).uploadInput.inputFileType === '発注')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, [
              _createElementVNode("input", {
                checked: _unref(state).linkingInput.orderExcelInfoSaveMode === 'append',
                type: "radio",
                name: "order-excel-info-save-mode",
                value: "append",
                onChange: _cache[0] || (_cache[0] = ($event: any) => (updateOrderExcelInfoSaveMode('append')))
              }, null, 40, _hoisted_10),
              _createElementVNode("span", null, _toDisplayString(_unref(t)('既存の設定に追加する')), 1)
            ]),
            (savedOrderExcelInfos.value && savedOrderExcelInfos.value.length > 0)
              ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
                  _createElementVNode("input", {
                    checked: _unref(state).linkingInput.orderExcelInfoSaveMode === 'replace',
                    type: "radio",
                    name: "order-excel-info-save-mode",
                    value: "replace",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (updateOrderExcelInfoSaveMode('replace')))
                  }, null, 40, _hoisted_12),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('既存の設定を置き換える')), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(state).linkingInput.orderExcelInfoSaveMode === 'replace' && savedOrderExcelInfos.value.length > 0)
              ? (_openBlock(), _createElementBlock("select", {
                  key: 1,
                  value: _unref(state).linkingInput.orderExcelInfoReplaceTargetId,
                  class: "order-save-mode__select",
                  onChange: updateOrderExcelInfoReplaceTargetId
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(savedOrderExcelInfos.value, (orderExcelInfo) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: orderExcelInfo.id,
                      value: orderExcelInfo.id
                    }, _toDisplayString(orderExcelInfo.name), 9, _hoisted_14))
                  }), 128))
                ], 40, _hoisted_13))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_unref(state).uploadInput.inputFileType === '発注')
        ? (_openBlock(), _createBlock(InputOrderExcelForm, {
            key: 1,
            from: "LinkingInput",
            "selected-field-id": selectedFieldId.value,
            suggestions: selectedFieldSuggestions.value,
            "order-excel-infos": _unref(state).linkingInput.orderExcelInfos,
            onUpdateSelectedFieldId: _cache[2] || (_cache[2] = 
          (id) => {
            selectedFieldId.value = id;
          }
        ),
            onUpdateOrderExcelInfos: updateOrderExcelInfos
          }, null, 8, ["selected-field-id", "suggestions", "order-excel-infos"]))
        : (_openBlock(), _createBlock(InputExcelForm, {
            key: 2,
            from: "LinkingInput",
            "selected-field-id": selectedFieldId.value,
            suggestions: selectedFieldSuggestions.value,
            "use-format-type": _unref(state).uploadInput.useFormatType,
            "alterable-header-infos": _unref(state).linkingInput.alternateHeaderInfos,
            "inlined-year-month-info": _unref(state).linkingInput.inlinedYearMonthInfo,
            "in-header-year-month-info": _unref(state).linkingInput.inHeaderYearMonthInfo,
            onUpdateSelectedFieldId: _cache[3] || (_cache[3] = 
          (id) => {
            selectedFieldId.value = id;
          }
        ),
            onUpdateSelectedField: updateSelectedField,
            onUpdateInlineHeaderName: updateInlineHeaderName,
            onUpdateInHeaderStartColumnNumber: updateInHeaderStartColumnNumber,
            onUpdateInHeaderEndColumnNumber: updateInHeaderEndColumnNumber,
            onUpdateInHeaderStart: updateInHeaderStart,
            onUpdateInHeaderEnd: updateInHeaderEnd
          }, null, 8, ["selected-field-id", "suggestions", "use-format-type", "alterable-header-infos", "inlined-year-month-info", "in-header-year-month-info"]))
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(TextButton, {
        "button-style": 'btn-secondary',
        size: 'btn-md',
        "on-click": onClickBackButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：戻るボタン')), 1)
        ], undefined, true),
        _: 1
      }),
      _createVNode(TextButton, {
        "button-style": 'btn-primary',
        size: 'btn-md',
        "on-click": onClickNextButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：登録ボタン')), 1)
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})